module.exports = __webpack_public_path__ + "static/media/backgroundPattern.4dac564f.svg";